<template>
  <div>
    <y-shelf title="我的订单">
      <div slot="content">
        <div v-loading="loading" element-loading-text="加载中..." v-if="orderList.length" style="min-height: 10vw;">
          <div v-for="(item,i) in orderList" :key="i">
            <div class="gray-sub-title cart-title">
              <div class="first">
                <div>
                  <span class="date" v-text="dateToString(item.createTime)"></span>
                  <span class="order-id"> 订单号：{{item.orderSn}} </span>
                </div>
                <div class="f-bc">
                  <span class="price">单价</span>
                  <span class="num">数量</span>
<!--                  <span class="operation">商品操作</span>-->
                </div>
              </div>
              <div class="last">
                <span class="sub-total">总金额</span>
                <span class="order-detail">状态</span>
              </div>
            </div>
            <div class="pr">
              <div class="cart" v-for="(good,j) in item.items" :key="j">
                <div class="cart-l" :class="{bt:j>0}">
                  <div class="car-l-l">
                    <div class="img-box"><a @click="goodsDetails(good.pid)"><img :src="getImgPath(good.productPic)" alt=""></a></div>
                    <div class="ellipsis"><a style="color: #626262;" @click="goodsDetails(good.pid)">{{good.productName}}</a></div>
                  </div>
                  <div class="cart-l-r">
                    <div class="price">¥ {{good.productPrice}}</div>
                    <div class="num">{{good.productQuantity}}</div>
                    <!--<div class="type">
                      <el-button style="margin-left:20px" @click="_delOrder(item.orderSn,i)" type="danger" size="small" v-if="j<1" class="del-order">删除此订单</el-button>
                      <a @click="_delOrder(item.orderId,i)" href="javascript:;" v-if="j<1" class="del-order">删除此订单</a>
                    </div> -->
                  </div>
                </div>
                <div class="cart-r">
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div class="prod-operation pa" style="right: 0;top: 0;">
                <div class="total">¥ {{item.totalAmount}}</div>
<!--                <div v-if="item.orderStatus === '0'">
                  <el-button @click="orderPayment(item.orderId)" type="primary" size="small">现在付款</el-button>
                </div>-->
                <div class="status" v-if="item.orderStatus !== '0'"> {{getOrderStatus(item.orderStatus)}}  </div>
              </div>
            </div>
          </div>
        </div>
        <div v-loading="loading" element-loading-text="加载中..." class="no-info" v-else>
          <div style="padding: 100px 0;text-align: center">
            你还未创建过订单
          </div>
        </div>
      </div>
    </y-shelf>
    <div style="text-align: center">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
  import YShelf from '../../../components/Shelf/shelf'
  import { getCookie } from '@/utils/support';
  import { fetchList, getItems } from '@/api/order'
  import { formatDate } from '@/utils/date';
  import { fetchList as fetchCartList } from '@/api/cart'
  import {setStore} from "../../../utils/storage";
  import {mapMutations} from "vuex";
  import good404 from '@/assets/images/good_404.png'

  export default {
    data () {
      return {
        orderList: [],
        userId: '',
        orderStatus: '',
        loading: true,
        currentPage: 1,
        pageSize: 5,
        total: 0
      }
    },
    methods: {
      ...mapMutations(['INIT_BUYCART']),
      //date类型转String类型
      dateToString(date){
        var date = new Date(date).toJSON();
        var newDate=new Date(+new Date(date)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
        return newDate;
      },
      getImgPath (url) {
        if (url === undefined || url === null || url === '') {
          return good404
        }
        return process.env.BASE_API + '/home/img'+ url;
      },
      message (m) {
        this.$message.error({
          message: m
        })
      },
      handleSizeChange (val) {
        this.pageSize = val
        this._orderList()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this._orderList()
      },
      orderPayment (orderId) {
        window.open(window.location.origin + '#/order/payment?orderId=' + orderId)
      },
      goodsDetails (id) {
        window.open(window.location.origin + '#/tourist/goodsDetails?id=' + id)
      },
      orderDetail (orderId) {
        this.$router.push({
          path: 'orderDetail',
          query: {
            orderId: orderId
          }
        })
      },
      getOrderStatus (value) {
        if (value === 1) {
          return '待发货';
        } else if (value === 2) {
          return '已发货';
        } else if (value === 3) {
          return '已完成';
        } else if (value === 4) {
          return '已退款';
        } else if (value === 5) {
          return '无效订单';
        } else {
          return '待付款';
        }
      },
      _orderList () {
        let sDate = new Date();
        let eDate = new Date();
        sDate.setDate(sDate.getDate() - 30);
        let params = {
          username: this.userId,
          psTime: formatDate(sDate, 'yyyy-MM-dd hh:mm:ss'),
          peTime: formatDate(eDate, 'yyyy-MM-dd hh:mm:ss'),
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        fetchList(params).then(response => {
          this.total = response.total;
          this._getItem(response.data)
          this.loading = false
        });
      },
      _getItem (data) {
        let items = []
        for (let i in data) {
          items.push({orderSn: data[i].orderSn, orderSoure: data[i].orderSoure})
        }
        let params = {
          items: items
        }
        getItems(params).then(res => {
          if (res.data !== undefined && res.data !== null && res.data.length > 0) {
            for (let j in data) {
              data[j].items = []
              for (let i in res.data) {
                if (data[j].orderSn === res.data[i].orderSn) {
                  data[j].items.push(res.data[i])
                }
              }
            }
          }
        })
        this.orderList = data;
      },
      _delOrder (orderId, i) {
        let params = {
          params: {
            orderId: orderId
          }
        }
        delOrder(params).then(res => {
          if (res.success === true) {
            this.orderList.splice(i, 1)
          } else {
            this.message('删除失败')
          }
        })
      },
      _getCartList() {
        fetchCartList({username: this.userId}).then(res => {
          let buyCart = []
          if (res.data !== undefined && res.data !== null && res.data.length > 0) {
            for (let i in res.data) {
              buyCart.push({
                productId: res.data[i].pid,
                salesPrice: res.data[i].productPrice,
                productName: res.data[i].productName,
                productImg: res.data[i].productPic,
                productNum: res.data[i].quantity,
                checked: res.data[i].checked
              })
            }
          }
          setStore('buyCart', buyCart)
        }).then(this.INIT_BUYCART)
      }
    },
    created () {
      this.userId = getCookie("username")
      this._orderList()
      this._getCartList();
    },
    components: {
      YShelf
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../../assets/style/mixin";
  @import "../../../assets/style/index";
  @media screen and (min-width: 600px) {
    .gray-sub-title {
      height: 38px;
      padding: 0 24px;
      background: #EEE;
      border-top: 1px solid #DBDBDB;
      border-bottom: 1px solid #DBDBDB;
      line-height: 38px;
      font-size: 12px;
      color: #666;
      display: flex;
      span {
        display: inline-block;
        height: 100%;
      }
      .first {
        display: flex;
        justify-content: space-between;
        flex: 1;
        .f-bc {
          > span {
            width: 112px;
            text-align: center;
          }
        }
      }
      .last {
        width: 230px;
        text-align: center;
        display: flex;
        border-left: 1px solid #ccc;
        span {
          flex: 1;
        }
      }
    }

    .bt {
      border-top: 1px solid #EFEFEF;
    }

    .date {
      padding-left: 0px;
    }

    .order-id {
      margin-left: 25px;
    }

    .cart {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      &:hover {
        .del-order {
          display: block;
        }
      }
      .del-order {
        display: none;
      }
      .cart-l {
        display: flex;
        align-items: center;
        flex: 1;
        padding: 15px 0;
        justify-content: space-between;
        position: relative;
        &:before {
          position: absolute;
          content: ' ';
          right: -1px;
          top: 0;
          width: 1px;
          background-color: #EFEFEF;
          height: 100%;
        }
        .ellipsis {
          margin-left: 20px;
          width: 220px;
        }
        .img-box {
          border: 1px solid #EBEBEB;
        }
        img {
          display: block;
          @include wh(80px);
        }
        .cart-l-r {
          display: flex;
          > div {
            text-align: center;
            width: 112px;
          }
        }
        .car-l-l {
          display: flex;
          align-items: center;
        }
      }
      .cart-r {
        width: 230px;
        display: flex;
        span {
          text-align: center;
          flex: 1;
        }
      }
    }

    .prod-operation {
      height: 110px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 254px;
      div {
        width: 100%;
        text-align: center;
      }
      div:last-child {
        padding-right: 24px;
      }
    }
  }

  @media screen and (max-width: 500px) {

    .gray-sub-title {
      height: 20px;
      padding: 0 5px;
      background: #EEE;
      border-top: 1px solid #DBDBDB;
      border-bottom: 1px solid #DBDBDB;
      line-height: 20px;
      font-size: 6px;
      color: #666;
      display: flex;
      span {
        height: 100%;
      }
      .first {
        display: flex;
        justify-content: space-between;
        width: 75%;
        flex: 1;
        .f-bc {
          > span {
            margin-left: 40px;
            text-align: center;
          }
        }
      }
      .last {
        width: 25%;
        text-align: center;
        display: flex;
        border-left: 1px solid #ccc;
        span {
          flex: 1;
        }
      }
    }

    .bt {
      border-top: 1px solid #EFEFEF;
    }

    .date {
      display: block;
      padding-left: 0px;
    }

    .order-id {
      display: none;
    }

    .cart {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 5px;
      &:hover {
        .del-order {
          display: block;
        }
      }
      .del-order {
        display: none;
      }
      .cart-l {
        display: flex;
        align-items: center;
        flex: 1;
        padding: 5px 0;
        justify-content: space-between;
        position: relative;
        &:before {
          position: absolute;
          content: ' ';
          right: -1px;
          top: 0;
          width: 1px;
          background-color: #EFEFEF;
          height: 100%;
        }
        .ellipsis {
          margin-left: 5px;
          font-size: 12px;
        }
        .img-box {
          border: 1px solid #EBEBEB;
        }
        img {
          display: block;
          @include wh(40px);
        }
        .cart-l-r {
          display: flex;
          > div {
            text-align: center;
            font-size: 12px;
            width: 50px;
          }
        }
        .car-l-l {
          display: flex;
          align-items: center;
        }
      }
      .cart-r {
        width: 25%;
        display: flex;
        span {
          text-align: center;
          flex: 1;
        }
      }
    }

    .prod-operation {
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      width: 25%;
      div {
        width: 100%;
        text-align: center;
      }
      div:last-child {
        padding-right: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/tourist/order/order.vue